module.exports = __webpack_public_path__ + "static/media/icon-close.7c236c9b.svg";